// enum for possible rellenos 
export const Rellenos = {
    'coco' : {name: 'Coco', color: '#8B4513'},
    'pina': {name: 'Piña', color: '#FFFF00'},
    'durazno': {name: 'Durazno', color: '#FFA500'},
    'nuez': {name: 'Nuez', color: '#8B4513'},
    'fresa': {name: 'Fresa', color: '#FF4D6D'},
    'chantilly': {name: 'Chantilly', color: '#FFFFFF'},
}
